import { TEMPLATE_ROUTES } from '../../template-routes';

export type PreviewRoute = {
  name: string;
  mailgunUrl: string;
  interpolatedUrl: string;
};

export const getPreviewPaths = (): PreviewRoute[] =>
  TEMPLATE_ROUTES.flatMap(({ path, name }) => ({
    name,
    mailgunUrl: `/preview/mailgun/${path}`,
    interpolatedUrl: `/preview/interpolate/${path}`,
  }));
